import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/Image';

import { getContentImageByMode } from '../../../../utils/imageUtils';
import ComingSoonImage from '../../../../static/images/no-image.png';

function BannerItem({
  content
}) {
  const getBackgroundImageURL = React.useCallback(
    (imagesArray) => {
      let imageURL = null;
      const found = getContentImageByMode(imagesArray, 'THUMB');
      imageURL = found && found.url;

      if (!imageURL) {
        console.error('Content must have an image of type "THUMB" to render!');
      }

      return imageURL;
    }, []
  );

  const contentBackgroundImage = getBackgroundImageURL(content.images);
  const backgroundStyle = {
    backgroundSize: `${contentBackgroundImage ? 'cover' : 'contain'}`,
    backgroundImage: `url(${contentBackgroundImage || ComingSoonImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <div style={backgroundStyle} className="tbx-ContentHeader">
    </div>
  );
};

BannerItem.propTypes = {
  content: PropTypes.shape({
    images: PropTypes.array
  }).isRequired
};

export default BannerItem;
